export default "__VITE_ASSET__a2aca077__"